import type { EnvironmentFilter } from '@/domain/filters';

const VALID_ENVIRONMENTS: readonly EnvironmentFilter[] = [
    'production',
    'test',
    'staging',
    'playground',
    'webmcp',
    'agent_http',
    'connectors',
];
export const DEFAULT_ENVIRONMENTS: readonly EnvironmentFilter[] = ['production'];

/**
 * Parse the `environment` URL search param into an array of valid filters.
 * Returns `null` when the param is absent (caller should leave context untouched).
 * Returns `[]` for the legacy `'all'` value (no filter).
 */
export function parseEnvironmentsParam(raw: string | null): EnvironmentFilter[] | null {
    if (raw === null) return null;
    if (raw === 'all') return [];
    return raw
        .split(',')
        .map((p) => p.trim())
        .filter((p): p is EnvironmentFilter => VALID_ENVIRONMENTS.includes(p as EnvironmentFilter));
}

/**
 * Parse a previously-stored env selection from localStorage.
 * Falls back to the default selection when missing or fully invalid.
 * Preserves the legacy `'all'` sentinel as `[]` (no filter).
 */
export function parseStoredEnvironments(stored: string | null): EnvironmentFilter[] {
    if (!stored) return [...DEFAULT_ENVIRONMENTS];
    if (stored === 'all') return [];
    const parts = stored
        .split(',')
        .map((p) => p.trim())
        .filter((p): p is EnvironmentFilter => VALID_ENVIRONMENTS.includes(p as EnvironmentFilter));
    return parts.length > 0 ? parts : [...DEFAULT_ENVIRONMENTS];
}

export function serializeEnvironments(envs: EnvironmentFilter[]): string {
    if (envs.length === 0) return 'all';
    return envs.join(',');
}
